import { tokens } from '@sail/ui';
export const darkSailColorTokens = {
    icon: {
        $default: tokens.color.neutral[400],
        emphasized: tokens.color.neutral[0]
    },
    text: {
        $default: tokens.color.neutral[400],
        emphasized: tokens.color.neutral[0],
        subdued: tokens.color.neutral[400],
        action: {
            primary: {
                hovered: tokens.color.neutral[0],
                pressed: tokens.color.neutral[200]
            },
            secondary: {
                $default: tokens.color.neutral[0],
                hovered: tokens.color.neutral[100],
                pressed: tokens.color.neutral[200]
            }
        },
        onAction: {
            primary: {
                $default: tokens.color.neutral[900],
                hovered: tokens.color.neutral[900],
                pressed: tokens.color.brand[900]
            },
            secondary: {
                hovered: tokens.color.neutral[0],
                pressed: tokens.color.neutral[200]
            }
        },
        form: {
            $default: tokens.color.neutral[200],
            hovered: tokens.color.neutral[300],
            placeholder: tokens.color.neutral[400]
        }
    },
    background: {
        surface: tokens.color.neutral[900],
        offset: tokens.color.brand[900],
        action: {
            primary: {
                hovered: tokens.color.neutral[0],
                pressed: tokens.color.neutral[200]
            }
        },
        form: {
            $default: tokens.color.brand[800]
        }
    },
    border: {
        action: {
            primary: {
                hovered: tokens.color.neutral[0]
            }
        }
    }
};
export const darkHelmColorTokens = {
    gridLines: {
        dashed: 'rgba(66, 71, 112, 0.3)',
        solid: 'rgba(66, 71, 112, 0.3)'
    },
    annotationColor: '#8c9eb1',
    navColor: tokens.color.neutral[0],
    navHoverColor: tokens.color.neutral[0],
    navHoverOpacity: '0.6',
    cardBorderColor: '#0f395e',
    subcardBackground: '#1f4468',
    gridSubcardBackground: '#1f4468',
    tableIconColor: '#8c9eb1',
    stripeAccentLight: tokens.color.neutral[0],
    bulletColor: '#6b7c93',
    disclaimerTextColor: tokens.color.neutral[500],
    inlineCodeTextColor: tokens.color.neutral[0],
    inlineCodeBackground: '#1c4161',
    socialLogoColor: tokens.color.neutral[500],
    socialLogoHoverColor: tokens.color.neutral[0],
    customerLogoColor: tokens.color.neutral[0]
};

//# sourceMappingURL=Dark.js.map